export default "__VITE_ASSET__CzpFe8P$__"